import ReceivedPaymentDetailBodyGeneralInfo from "./components/ReceivedPaymentDetailBodyGeneralInfo/ReceivedPaymentDetailBodyGeneralInfo"
import ReceivedPaymentDetailBodyTable from "./components/ReceivedPaymentDetailBodyTable/ReceivedPaymentDetailBodyTable"
import './styles.css'

const ReceivedPaymentDetailBody = () => {

  return (
    <div className="received-payment-detail-body">
      <ReceivedPaymentDetailBodyGeneralInfo />
      <ReceivedPaymentDetailBodyTable />
    </div>
  )
}

export default ReceivedPaymentDetailBody
